export enum TokenEnum {
    KAB = 'kab',
    GKAB = 'gkab',
    OKG = 'okg',
    GOKG = 'gokg',
    ALL = 'all',
}